import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center cursor-pointer" }
const _hoisted_2 = ["value", "id"]
const _hoisted_3 = { class: "ml-2" }

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwCheckbox',
  props: {
  options: {
    type: Array as () => Array<{ label: string; value: string }>,
    required: true,
  },
  modelValue: {
    type: Array as () => string[],
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const localValues = ref([...props.modelValue]);

watch(
  () => props.modelValue,
  (newValue) => {
    localValues.value = [...newValue];
  },
  { immediate: true }
);

const updateValue = () => {
  emits("update:modelValue", localValues.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.value,
        class: "flex items-center mt-2 mb-2"
      }, [
        _createElementVNode("label", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: option.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValues).value = $event)),
            id: option.value,
            class: "form-checkbox",
            onChange: updateValue
          }, null, 40, _hoisted_2), [
            [_vModelCheckbox, localValues.value]
          ]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})